import { useEffect, useState } from "react";
import styles from "./DemoList.module.css";

const DemoList = () => {
  const [demoforms, setDemoforms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDemoforms = async () => {
      try {
        const response = await fetch(
          "https://prod.toxboxai.com/api/demo"
        );
        const result = await response.json();
        if (result.success) {
          setDemoforms(result.data);
        }
      } catch (error) {
        console.error("Error fetching demo forms:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDemoforms();
  }, []);

  if (loading) {
    return <div className={styles.loading}>Loading...</div>;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>All Demo Forms</h1>
      <div className={styles.cardContainer}>
        {demoforms.length === 0 ? (
          <p className={styles.noData}>No demo forms available.</p>
        ) : (
          demoforms.map((form, index) => (
            <div key={index} className={styles.card}>
              <h2 className={styles.cardTitle}>
                {form.firstName} {form.lastName}
              </h2>
              <p className={styles.cardText}>
                <strong>Company:</strong> {form.companyName}
              </p>
              <p className={styles.cardText}>
                <strong>Email:</strong> {form.businessEmail}
              </p>
              <p className={styles.cardText}>
                <strong>Job Title:</strong> {form.jobTitle}
              </p>
              <p className={styles.cardText}>
                <strong>Phone:</strong> {form.phone || "N/A"}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DemoList;
